import React, { useRef, useState, useEffect } from "react";
import Message from "../../helper/Message";
import { Table } from "antd";
import Search from "./Search/Search";

import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";

import Highlighter from "react-highlight-words";
import moment from "moment";
import Axios from "axios";
import constants from "../../constants/constants.json";

export default function Payments(param) {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      close,
    }) => (
      <Search
        setSearchText={setSearchText}
        setSelectedKeys={setSelectedKeys}
        selectedKeys={selectedKeys}
        confirm={confirm}
        clearFilters={clearFilters}
        close={close}
        searchInput={searchInput}
        handleSearch={handleSearch}
        handleReset={handleReset}
        dataIndex={dataIndex}
        setSearchedColumn={setSearchedColumn}
      />
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1677ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: "name",
      dataIndex: "userName",
      key: "userName",
      ...getColumnSearchProps("userName"),
    },
    {
      title: "email",
      dataIndex: "userMail",
      key: "userMail",
      ...getColumnSearchProps("userMail"),
    },
    {
      title: "gateway",
      dataIndex: "paymentGateway",
      key: "paymentGateway",
    },
    {
      title: "value",
      dataIndex: "paymentValue",
      key: "paymentValue",
    },
    {
      title: "status",
      dataIndex: "paymentStatus",
      key: "paymentStatus",
      render: (status, record) => {
        return record.paymentStatus === 1 ? (
          <CheckCircleOutlined style={{ color: "green", fontSize: "18px" }} />
        ) : (
          <CloseCircleOutlined style={{ color: "red", fontSize: "18px" }} />
        );
      },
    },
    {
      title: "createTime",
      dataIndex: "paymentCreateTime",
      key: "paymentCreateTime",
      ...getColumnSearchProps("paymentCreateTime"),
      render: (status, record) => {
        return (
          <spann>
            {moment(record.paymentCreateTime, "X").format("YYYY-MM-DD")}
          </spann>
        );
      },
    },
  ];

  const fetchPayments = async () => {
    try {
      setLoading(true);
      const res = await Axios.get(constants.url + "/admin/payments", {
        headers: {
          authorization: "Bearer " + localStorage.getItem("pnsToken"),
        },
      });
      if (res.data.status === 202) {
        setPayments(res.data.result.payments);
      } else {
        Message.warning(res.data.result.message);
      }
      setLoading(false);
    } catch (error) {
      Message.error("Communication error");
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchPayments();
  }, []);
  return (
    <Table
      loading={loading}
      dataSource={payments}
      columns={columns}
      pagination={false}
    />
  );
}
